export default __webpack_public_path__ + "static/media/nfo-banner-consumption-comp-mobile.02bb13ac.jpg";